import { useState } from "react";
import {
  BagIcon, // 袋子圖標
} from "./constants/icons";

// 編輯設備資訊的彈窗組件
export default function EditDeviceModal({
  currentMode,
  node,
  onSave,
  onClose,
}) {
  const [formData, setFormData] = useState(() => {
    return {
      name: node.name || "",
      architecture: node.fieldsValues?.architecture || "",
      endDevice: node.fieldsValues?.endDevice || "",
      phases: node.fieldsValues?.phases || "",
      voltage: node.fieldsValues?.voltage || "",
      ampere: node.fieldsValues?.ampere || "",
    };
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    onSave(node.id, formData);
  };

  const Icon = node.icon || BagIcon;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-gray-800 rounded-lg p-6 max-w-lg w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        {/* 標題 */}
        <div className="flex items-center gap-3 mb-6">
          <Icon />
          <div>
            <h3 className="text-lg font-semibold text-white">
              編輯 {node.name}
            </h3>
            <p className="text-sm text-gray-400">{node.name}</p>
          </div>
        </div>

        {/* 表單內容 */}
        <div className="space-y-4">
          <>
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                副標題
              </label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => handleInputChange("name", e.target.value)}
                className="w-full bg-white/10 border border-white/20 rounded px-3 py-2 text-white text-sm"
                placeholder="請輸入副標題"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                建築位置
              </label>
              <input
                type="text"
                value={formData.architecture}
                onChange={(e) =>
                  handleInputChange("architecture", e.target.value)
                }
                className="w-full bg-white/10 border border-white/20 rounded px-3 py-2 text-white text-sm"
                placeholder="請輸入建築位置"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                終端設備名稱
              </label>
              <input
                type="text"
                value={formData.endDevice}
                onChange={(e) => handleInputChange("endDevice", e.target.value)}
                className="w-full bg-white/10 border border-white/20 rounded px-3 py-2 text-white text-sm"
                placeholder="請輸入終端設備名稱"
              />
            </div>
            {currentMode === 1 && (
              <>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    相數
                  </label>
                  <input
                    type="text"
                    value={formData.phases}
                    onChange={(e) =>
                      handleInputChange("phases", e.target.value)
                    }
                    className="w-full bg-white/10 border border-white/20 rounded px-3 py-2 text-white text-sm"
                    placeholder="請輸入相數"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    電壓V
                  </label>
                  <input
                    type="text"
                    value={formData.voltage}
                    onChange={(e) =>
                      handleInputChange("voltage", e.target.value)
                    }
                    className="w-full bg-white/10 border border-white/20 rounded px-3 py-2 text-white text-sm"
                    placeholder="請輸入電壓"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    斷路器規格A
                  </label>
                  <input
                    type="text"
                    value={formData.ampere}
                    onChange={(e) =>
                      handleInputChange("ampere", e.target.value)
                    }
                    className="w-full bg-white/10 border border-white/20 rounded px-3 py-2 text-white text-sm"
                    placeholder="請輸入斷路器規格"
                  />
                </div>
              </>
            )}
          </>
        </div>

        {/* 按鈕區域 */}
        <div className="flex gap-3 mt-6">
          <button
            onClick={handleSave}
            className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded text-white transition-colors"
          >
            儲存
          </button>
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded text-white transition-colors"
          >
            取消
          </button>
        </div>
      </div>
    </div>
  );
}
